import { toast, ToastContent, type ToastOptions, ToastType } from 'vue3-toastify';

// region - toast
export function notifyToast(message: string) {
  if (message.trim().length > 0) {
    toast(message, {} as ToastOptions);
  }
}

export function pendingToast(message: string) {
  return toast.loading(message, {
    autoClose: false,
    closeOnClick: true,
    closeButton: true,
  });
}

export function updateToast(
  toastId: string | number,
  message: ToastContent,
  type: ToastType,
  autoClose = 5000,
  onClose?: () => void
) {
  toast.update(toastId, {
    isLoading: false,
    render: message,
    type: type,
    autoClose: autoClose,
    closeButton: true,
    closeOnClick: true,
    onClose: onClose,
  });
}

export function closeToast(toastId: string | number) {
  toast.remove(toastId);
}

export function infoToast(message: string, onClose?: () => void) {
  if (message.trim().length > 0) {
    toast(message, {
      type: 'info',
      onClose: onClose,
    } as ToastOptions);
  }
}

export function successToast(message: string, onClose?: () => void) {
  if (message.trim().length > 0) {
    toast(message, {
      type: 'success',
      onClose: onClose,
    } as ToastOptions);
  }
}

export function warningToast(message: string, onClose?: () => void) {
  if (message.trim().length > 0) {
    toast(message, {
      type: 'warning',
      onClose: onClose,
    } as ToastOptions);
  }
}

export function errorToast(message: string, onClose?: () => void) {
  if (typeof message === 'object') {
    console.error('Toast message is object: ', message);
    message = 'Toast message is object!';
  }

  if (message.trim().length > 0) {
    toast(message, {
      type: 'error',
      onClose: onClose,
    } as ToastOptions);
  }
}

// endregion
